import { theme } from '@superhi/design'
import styled from 'styled-components'

import { SIZE } from './components/Wilson'

export const WilsonMissing = styled.div`
  width: ${SIZE.small - 4}px;
  height: ${SIZE.small - 4}px;
  border-radius: ${SIZE.small - 4}px;
  border: 2px dashed ${theme.colors.GREY_60};
  margin: 2px;

  @media ${theme.breakpoints.medium} {
    width: ${SIZE.medium - 4}px;
    height: ${SIZE.medium - 4}px;
    border-radius: ${SIZE.medium - 4}px;
  }

  @media ${theme.breakpoints.large} {
    width: ${SIZE.large - 4}px;
    height: ${SIZE.large - 4}px;
    border-radius: ${SIZE.large - 4}px;
  }
`
